import { clickableObjectTypes } from './tabletObjects';

export const activeInspectorTypes = {
    LAYER: 'layer',
    LITHOLOGY: 'lithology',
    CURVES: 'curve',
    PERFORATION: 'perforation',
    WELL: 'well',
    GROUP: 'group',
    DEFAULT: 'well',
};

export const clickableTypesByView = {
    [clickableObjectTypes.CURVES]: activeInspectorTypes.CURVES,
    [clickableObjectTypes.LAYER]: activeInspectorTypes.LAYER,
    [clickableObjectTypes.PERFORATION]: activeInspectorTypes.PERFORATION,
    [clickableObjectTypes.LITHOLOGY]: activeInspectorTypes.LITHOLOGY,
};
